// src/pages/Home.jsx
import { useEffect } from "react";

// Neue Sektionen
import GoogleReviewsSection from "../sections/GoogleReviews";
import Hero from "../sections/Hero";
import Features from "../sections/Features";
import Highlights from "../sections/Highlights";
import BlogTeaser from "../sections/BlogTeaser";
// import SuccessStories from "../sections/SuccessStories"; // TODO: später mit echten Stories
import CTA from "../sections/CTA";

const BLOG = [
    {
        title: "Waschbär fangen mit der Betonrohrfalle",
        slug: "waschbaer-fangen-betonrohrfalle",
        excerpt: "Standortwahl, Köderung und rechtliche Grundlagen für die erfolgreiche Waschbärbejagung.",
        date: "2026-02-11",
        cover: "/images/blog/blog-waschbaeren-hero.webp",
    },
    {
        title: "Betonrohrfalle vs. Kastenfalle",
        slug: "betonrohrfalle-vs-kastenfalle",
        excerpt: "Welche Falle ist besser? Wir vergleichen Vor- und Nachteile beider Systeme.",
        date: "2026-02-11",
        cover: "/images/blog/blog-betonrohrfallevskastenfalle-hero.webp",
    },
    {
        title: "Fallenjagd: Rechtliche Grundlagen 2026",
        slug: "fallenjagd-rechtliche-grundlagen",
        excerpt: "Jagdschein, Sachkundenachweis, Kontrollpflichten – alles was Sie wissen müssen.",
        date: "2026-02-11",
        cover: "/images/blog/blog-jagdrecht.hero.webp",
    },
];

export default function Home() {
    useEffect(() => {
        document.title = "Betonrohrfalle kaufen | 40 Jahre Erfahrung | Tuscher Helmut";

        // Meta Description setzen (SEO-optimiert)
        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) {
            metaDesc.setAttribute("content", "Betonrohrfalle kaufen vom Experten ✓ 40 Jahre Praxiserfahrung ✓ Fuchs, Waschbär, Marder, Dachs ✓ Tierschutzkonform ✓ Made in Germany ➤ Jetzt Shop entdecken!");
        }

        // Canonical URL setzen
        let canonical = document.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement('link');
            canonical.rel = 'canonical';
            document.head.appendChild(canonical);
        }
        canonical.href = 'https://tuscherhelmut-betonrohrfallen.de/';
    }, []);

    return (
        <div className="relative overflow-hidden min-h-screen">
            {/* Vertrauens- & Aktions-Banner */}
            <div className="relative z-20 bg-slate-50 dark:bg-slate-900 border-b border-slate-100 dark:border-slate-800">
                <div className="mx-auto max-w-6xl px-4 py-3">
                    <div className="flex flex-col lg:flex-row items-center justify-between gap-4">
                        {/* Trust Section */}
                        <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-6 text-center lg:text-left">
                            <div className="flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-brand-600">
                                <span className="h-1.5 w-1.5 rounded-full bg-brand-600 animate-pulse" />
                                Vom Jäger - Für den Jäger
                            </div>
                            <div className="hidden sm:block h-4 w-px bg-slate-200 dark:bg-slate-700" />
                            <p className="text-[11px] font-bold text-slate-500 dark:text-slate-400 italic leading-tight">
                                "Vertrauen Sie auf meine 50-jährige Erfahrung in der Raubwildbejagung."
                            </p>
                        </div>

                    </div>
                </div>
            </div>

            {/* Background Decor */}
            <div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
                <div className="absolute top-0 left-[10%] h-[40%] w-[40%] rounded-full bg-brand-500/5 blur-[120px]" />
            </div>

            <Hero />
            <Features />
            <Highlights />
            {/* <SuccessStories /> */}{/* TODO: später mit echten Stories */}
            <BlogTeaser posts={BLOG} />
            <GoogleReviewsSection
                title="Was meine Kundinnen & Kunden sagen"
                subtitle="Echt. Unverändert. Von Google."
                ctaTo="https://g.page/r/CcB_B2dngBtxEBM/review"
            />
            <CTA />

        </div>
    );
}
